'use client';

import dynamic from 'next/dynamic';

export const ScrollToTopButtonLazy = dynamic(
  () =>
    import('@/features/products/components/scrollToTopButton/scrollToTopButton').then(
      (mod) => mod.ScrollToTopButton
    ),
  { ssr: false }
);
